import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './assets/styles.scss';
import Input from '../../../components/Input/Input';
import Detail from '../../../components/Detail/Detail';

const cx = classNames.bind(styles);

export default function RandomNumber({
  txIds, seedHash, onTxIdChange, isCardOrder,
}) {
  function getContent() {
    return (
      <div className={cx('hidden')}>
        <span className={cx('small')}>{seedHash}</span>
        {txIds.map((txId, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={cx('mt-8', 'flex-center')} key={index}>
            <span className={cx('small')}>+</span>
            <Input value={txId} className={cx('list-detail')} onChange={newValue => onTxIdChange(index, newValue)} />
          </div>
        ))}
        {isCardOrder && (
          <>
            <hr className={cx('hr')} />
            <div>
              <span>+</span>
              <span className={cx('algorithm', 'small')}>Fisher-Yates Shuffle Algorithm</span>
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <Detail
      className={cx('random-number')}
      contentClassName={cx('content')}
      label={isCardOrder ? 'Card Order' : 'Random Number'}
      content={getContent()}
      copyText={seedHash}
      copiable={!!seedHash}
    />
  );
}

RandomNumber.propTypes = {
  txIds: PropTypes.arrayOf(PropTypes.string),
  seedHash: PropTypes.string.isRequired,
  onTxIdChange: PropTypes.func,
  isCardOrder: PropTypes.bool,
};
RandomNumber.defaultProps = {
  txIds: [],
  onTxIdChange: null,
  isCardOrder: false,
};
